import api from '../utils/api';

// Parâmetros do sistema editáveis no Painel Admin.

const autorizar = () => {
    const token = localStorage.getItem('token');
    api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;
};

export const getConfiguracoes = async () => {
    try {
        autorizar();
        const { data } = await api.get('/configuracoes');
        return data?.configuracoes || [];
    } catch (error) {
        return [];
    }
};

export const getConfiguracao = async (chave) => {
    try {
        autorizar();
        const { data } = await api.get(`/configuracoes/${chave}`);
        return data;
    } catch (error) {
        return null;
    }
};

// Deixa o erro subir: a tela precisa mostrar o motivo da recusa (e-mail
// inválido, lista vazia, sem permissão) em vez de falhar em silêncio.
export const salvarConfiguracao = async (chave, valor) => {
    autorizar();
    const { data } = await api.patch(`/configuracoes/${chave}`, { valor });
    return data;
};

const ConfiguracaoService = { getConfiguracoes, getConfiguracao, salvarConfiguracao };

export default ConfiguracaoService;
